import {
  EXPLORE_DEFINITIONS,
  type ExploreViewDefinition,
} from './visualizations';

function createExploreCard(
  definition: ExploreViewDefinition,
  position: number,
): HTMLElement {
  const card = document.createElement('article');
  card.className = `explore-card explore-card--${String(position + 1)}`;
  card.dataset.exploreCard = definition.id;
  const index = document.createElement('span');
  index.className = 'explore-card__number';
  index.textContent = String(position + 1).padStart(2, '0');
  const eyebrow = document.createElement('p');
  eyebrow.className = 'eyebrow eyebrow--gold';
  eyebrow.textContent = definition.eyebrow;
  const heading = document.createElement('h2');
  const link = document.createElement('a');
  link.href = `/explore/${definition.id}`;
  link.dataset.router = '';
  link.textContent = definition.title;
  heading.append(link);
  const copy = document.createElement('p');
  copy.textContent = definition.description;
  const action = document.createElement('span');
  action.className = 'text-link';
  action.textContent = 'Open visualization';
  card.append(index, eyebrow, heading, copy, action);
  return card;
}

export function createExploreIndex(): HTMLElement {
  const page = document.createElement('div');
  page.className = 'explore-index page-width';
  page.dataset.route = 'explore-index';
  const header = document.createElement('header');
  header.className = 'explore-heading explore-heading--index';
  const eyebrow = document.createElement('p');
  eyebrow.className = 'eyebrow eyebrow--gold';
  eyebrow.textContent = 'Explore';
  const title = document.createElement('h1');
  title.textContent = 'See the conference from another angle';
  const copy = document.createElement('p');
  copy.textContent =
    'Use validated conference analysis as a starting point, then continue into the official talk text or a guided thread.';
  header.append(eyebrow, title, copy);
  const grid = document.createElement('div');
  grid.className = 'explore-grid';
  for (const [position, definition] of EXPLORE_DEFINITIONS.entries()) {
    grid.append(createExploreCard(definition, position));
  }
  page.append(header, grid);
  return page;
}
